import React, { useMemo } from 'react'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import isEmpty from 'lodash/isEmpty'
import { useWealthJourneyQuery } from '../../../../api/wealthJourney'
import { useDailyGreetingShared } from './useDailyGreetingShared'
import { buildSubtitle } from './buildSubtitle'
import DailyGreetingShell from './DailyGreetingShell'
import { dailyGreetingShellPropTypes } from './dailyGreetingPropTypes'

dayjs.extend(utc)

function DailyGreetingWealthJourney ({
  userName,
  meetingsLinkTo: _meetingsLinkTo,
  tasksLinkTo: _tasksLinkTo,
  overdueStartDate,
  tasksLinkMode: _tasksLinkMode
}) {
  const shared = useDailyGreetingShared({
    userName,
    rawOverdueStartDate: overdueStartDate
  })
  const {
    classes,
    yesterday,
    overdueStartDate: resolvedOverdueStart,
    scope,
    meetingsRemainingCount,
    isLoadingMeetings,
    tasksDueTodayCount,
    isLoadingDueToday,
    greetingText
  } = shared

  const overdueEndDate = useMemo(
    () => (yesterday ? dayjs.utc(yesterday).endOf('day').format() : undefined),
    [yesterday]
  )

  const overdueQuery = useMemo(() => ({
    filters: {
      dueDate: [
        { op: 'gte', value: resolvedOverdueStart },
        { op: 'lte', value: overdueEndDate }
      ],
      status: [{ op: 'notIn', value: ['Completed'] }],
      ...(!isEmpty(scope?.values)
        ? { groupIds: [{ op: 'in', value: scope.values }] }
        : {})
    },
    resultType: 'total'
  }), [resolvedOverdueStart, overdueEndDate, scope])

  const { data: overdueCount, isLoading: isLoadingOverdue } = useWealthJourneyQuery(
    'daily-greeting-tasks-overdue',
    overdueQuery,
    {
      queryName: 'searchTasks',
      mapper: ({ total } = {}) => total ?? 0,
      enabled: Boolean(resolvedOverdueStart) && Boolean(overdueEndDate)
    }
  )

  const subtitleNode = useMemo(() => buildSubtitle({
    classes,
    meetingsRemainingCount,
    isLoadingMeetings,
    tasksDueTodayCount,
    isLoadingDueToday,
    overdueCount,
    isLoadingOverdue,
    includeOverdue: true
  }), [
    classes,
    meetingsRemainingCount,
    isLoadingMeetings,
    tasksDueTodayCount,
    isLoadingDueToday,
    overdueCount,
    isLoadingOverdue
  ])

  return (
    <DailyGreetingShell
      classes={classes}
      greetingText={greetingText}
      subtitleNode={subtitleNode}
    />
  )
}

DailyGreetingWealthJourney.propTypes = dailyGreetingShellPropTypes

export default DailyGreetingWealthJourney
